<template>
 <div class="popup" v-cloak v-if="updateVerifiShow">
     <div class="content" id="verificationUpdate">
           <div class="title">
                  {{$t('language.twoStepverification.twoStep')}}
                 <div class="icon white-close dialog-close" @click="closePage()"></div>
           </div>
           <div class="set-body-content" >
               <div style="width:100%;height:calc(100% - 50Px);float:left;lineHeight:20Px;">
                    <div style="float:left;height:40Px;width:100%;fontSize:14Px;">
                          <div style="float:left;width:195Px;"> <span style="color:#6f7886;" >{{$t('language.twoStepverification.twoStepis')}}</span>
                          <b v-if="verificationStatus=='on'">{{$t('language.twoStepverification.on')}}</b>
                          <b v-if="verificationStatus=='off'">{{$t('language.twoStepverification.off')}}</b></div>
                          <mySwitch style="float:left;position:relative;top:-2Px;left:5px;" @input="changeData" v-model="verificationStatus" ></mySwitch>
                    </div>
                    <div style="width:100%;float:left;fontSize:14Px;height:30Px;color:#6f7886;"> 
                        {{$t('language.twoStepverification.verifyIdenti')}}:
                    </div>
                    <div v-if="emialShow" style="width:100%;float:left;fontSize:14Px;height:35Px;"> 
                        <div style="color:#6f7886;float:left;width:100Px;" :style="{width:getEmailWidth()}">{{$t('language.twoStepverification.emailCode')}}</div>
                        <div style="marginLeft:50Px;width:200Px;textAlign:left;float:left;" :style="{marginLeft:getMarginLeft()}"><b>{{emialValue}}</b></div>
                        <span>
                        <div class="vertifiname-edit"  style="float:left;position:relative;top: 2Px;" title="Edit" @click="edit('email')"></div>
                        </span>
                        <div class="delete" style="float:right;cursor: pointer;" title="Remove" @click="toRemove('email')"></div>
                    </div>
                    <div v-if="txtShow" style="width:100%;float:left;fontSize:14Px;height:35Px;" ref="phoneTxt"> 
                        <div style="color:#6f7886;float:left;width:100Px;" :style="{width:getEmailWidth()}">{{$t('language.twoStepverification.TextCode')}}</div>
                        <div style="marginLeft:50Px;width:200Px;textAlign:left;float:left;" :style="{marginLeft:getMarginLeft()}"><b>{{phoneValue}}</b></div>
                        <span>
                        <div class="vertifiname-edit"   style="float:left;position:relative;top: 2Px;" title="Edit" @click="edit('phone')"></div>
                        </span>
                        <div class="delete" style="float:right;cursor: pointer;" title="Remove" @click="toRemove('phone')"></div>
                    </div>
                    <div style="position:relative;" ref="bottomPosition">
                    <div v-if="!(emialShow&&txtShow)" class="remove-all" @click="addWay()">
                          <span style="cursor: pointer;">+{{$t('language.twoStepverification.addWayVerify')}}</span>
                    </div>
                    
                    </div>
               </div>
               <div  class="remove-all" @click="removeAll()" >
                          <span style="cursor: pointer;">{{$t('language.twoStepverification.removeTrusted')}}</span>
               </div>
              <div style="width:100%;height:30Px;float:left;">
                   <div style="color:#2e79f6;float:left;lineHeight:30Px;cursor: pointer;" @click="replacecode()">{{$t('language.twoStepverification.getRecode')}}</div>
                   <button style="float:right;width:110Px;" @click="closePage()">{{$t('language.common.ok')}}</button>
              </div>
           </div>
    
     </div>
</div>
</template>
<script>

import areaCodeUtil from "../../../js/workspace/area_code_utils.js";
import commonstate from '@/js/constant.js';
import mySwitch from "@/components/common/input/verification_switch";
import commonUtils from "@/js/workspace/common_util.js";

export default {
    data() {
        return {
           cornet:'86',
           updateVerifiShow:false,//控制该弹窗的显示
           verificationStatus:'on',
           emialValue:'jimin0904@qq.com',
           emialShow:true,
           editshow:false,
           txtShow:true,
           phoneValue:'12345678',
           editPhoneShow:false,
           user:commonUtils.getUser()
        }
    },
    components:{
      mySwitch,
    },
    watch:{
        updateVerifiShow(newValue,oldValue){
             if(newValue){
             let that=this;
             this.$nextTick(()=>{
             that.getTop();
             });
              if(this.phoneValue && this.phoneValue.indexOf("-")!=-1){
                   let index = this.phoneValue.indexOf("-");
                   this.cornet = this.phoneValue.substring(0,index);
                   this.phoneValue = this.phoneValue.substring(index+1);
             }else{
                   areaCodeUtil.getAreacode(function(res){
                   if(res.cornet){
                   that.cornet=res.cornet;
                   }
                  });
             }
        }
        }
    },
    methods: {
        getTop(){
            var top=0;
            switch (this.$i18n.locale) {
            case 'spanish':
                this.$refs.bottomPosition.style.top=25+'Px'
                break;
            case 'japanese':
                this.$refs.bottomPosition.style.top=30+'Px'
                break;
        }
        },
        getEmailWidth(){
            var result;
            switch (this.$i18n.locale) {
            case 'portuguese':
                result = 120+'Px';
                return result;
                break;
             case 'spanish':
                  result = 130+'Px';
                return result;
                break;
            default:
                result = 100+'Px';
                return result;
                break;
            // case 'japanese':
            //     this.$refs.bottomPosition.style.top=30+'Px'
            //     break;
        }
        },
        getMarginLeft(){
            var result;
            let _self = this;
            switch (this.$i18n.locale) {
            case 'portuguese':
                this.$nextTick(()=>{
                     _self.$refs.phoneTxt.style.position='relative';
                     _self.$refs.phoneTxt.style.top=5+'Px';
                });
                result = 30+'Px';
                return result;
                break;
             case 'spanish':
                 this.$nextTick(()=>{
                     _self.$refs.phoneTxt.style.position='relative';
                     _self.$refs.phoneTxt.style.top=5+'Px';
                });
                result = 20+'Px';
                return result;
                break;
            default:
                result = 50+'Px';
                return result;
                break;
            }
        },
        closePage(){
            this.updateVerifiShow=false;
        },
        changeData(newValue){
         this.verificationStatus=newValue;
        },
        changeShow(){
            this.editshow=false;
        },
        editPhonechange(){
            this.editPhoneShow=false;
        },
        addWay(){
            let self= this.$parent.$refs.verifiSettingDialog;
            self.source="addTrust";
            self.verifiSettingShow=true;
            //如果现在是email设备则另一外一种只能是手机
            // if(this.emialShow){
            //     this.$nextTick(()=>{
            //         // self.onChangeOption('Add a phone number');
            //         // self.$refs.cloudSelect.source='addTrust';
            //         // self.$refs.cloudSelect.currentValue=this.$t('language.twoStepverification.addPhone');
            //          //获取用户所在地的区号
            //         //  areaCodeUtil.getAreacode(function(res){

            //         //  });
            //     })
            //     return;
               
            // }
            //如果现在是手机设备则另外一种只能是email
            //  if(this.txtShow){
            //        this.$nextTick(()=>{
            //              self.$refs.cloudSelect.source='addTrust';
            //              self.$refs.cloudSelect.currentValue=this.$t('language.twoStepverification.addAlEmail');
            //              self.onChangeOption(this.$t('language.twoStepverification.addAlEmail'));
            //        });
            //        return;
            //  }
            //1.	无论之前用户添加的是什么验证方式，“添加验证方式弹窗”始终默认展示邮箱验证方式：
              this.$nextTick(()=>{
                         self.$refs.cloudSelect.source = null;
                         self.$refs.cloudSelect.currentValue = this.$t('language.twoStepverification.addAlEmail');
                         self.selectOption = [
					{
						name: this.$t('language.twoStepverification.addPhone'),
						icon: false,
						id: 1
					}];
                         self.onChangeOption(this.$t('language.twoStepverification.addAlEmail'));
            });

        },
        removeAll(){
             //如果用户两种验证方式都没添加，则弹窗报错信息
            //  if((!this.emialShow && !this.txtShow)){
            //        this.$toast({
            //             text: this.$t('language.twoStepverification.addVerify'),
            //             type: 'fail',
            //             idValue: "verificationUpdate"
            //             });
            //         return;
            //  }
             this.$parent.$refs.removeAllDevicesDialog.cornet=this.cornet;
             this.$parent.$refs.removeAllDevicesDialog.email=this.emialValue;
             this.$parent.$refs.removeAllDevicesDialog.phoneNumber=this.phoneValue;
             this.$parent.$refs.removeAllDevicesDialog.removeAllShow=true;
             this.$parent.$refs.removeAllDevicesDialog.removeAll=true;
        },
        edit(value){
            let self=this.$parent.$refs.verifiSettingDialog;
            self.source="update";
            self.verifiSettingShow=true;
            this.$nextTick(()=>{
            self.$refs.cloudSelect.source='update';
            if(value == 'email'){
             self.$refs.cloudSelect.currentValue=this.$t('language.twoStepverification.addAlEmail');
             self.emailValue=this.emialValue;
             self.emailInputShow=true;
             self.phoneValue=null;
            }
            if(value == 'phone'){
             self.$refs.cloudSelect.currentValue=this.$t('language.twoStepverification.addPhone');
             self.phoneValue=this.phoneValue;
             self.cornet=this.cornet;
             self.emailInputShow=false;
             self.emailValue=null;
            }
            });
       
        },
        toRemove(value){
            if(value == 'email'){
             this.$parent.$refs.removeAllDevicesDialog.email=this.emialValue;
             this.$parent.$refs.removeAllDevicesDialog.phoneNumber=null;
            }
            if(value == 'phone'){
             this.$parent.$refs.removeAllDevicesDialog.phoneNumber=this.phoneValue;
             this.$parent.$refs.removeAllDevicesDialog.email=null;
            }
             this.$parent.$refs.removeAllDevicesDialog.cornet=this.cornet;
             this.$parent.$refs.removeAllDevicesDialog.removeAllShow=true;
             this.$parent.$refs.removeAllDevicesDialog.removeAll=false;
        },
        replacecode(){
               let that=this.$parent.$refs.verifiSettingDialog;
                    //如果用户两种验证方式都没添加，则弹窗报错信息
            //  if((!this.emialShow && !this.txtShow)){
            //        this.$toast({
            //             text: this.$t('language.twoStepverification.addVerify'),
            //             type: 'fail',
            //             idValue: "verificationUpdate"
            //             });
            //         return;
            //  }
               this.Utils.doDualVerifyRequest('recover',{userId:this.user.id}).then(res=>{
               if(res.status == 200){
                 that.recoveyCode = res.recoverCode;
                 that.verifiSettingShow = true;
                 this.$nextTick(()=>{
                 that.stepOneShow = false;
                 that.stepTwoShow = false;
                 that.stepThreeShow = true;
                 });
                  
                }else{
                        that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationUpdate"
                        });
                    return false;
                }
              });
             
        }
      
    }

}
</script>

<style>
#verificationUpdate{
    width: 440Px;
    height: 370Px;
}
.set-body-content{
    width: 100%;
    height: calc(100% - 40Px);
    box-sizing: border-box;
    padding: 30Px 20Px 20Px 20Px;
}
.remove-all{
    width:100%;
    float:left;
    font-size:14Px;
    height:30Px;
    color:#2e79f6;
}

.edit-remove{
width:230Px;
float:left;
margin:0Px 15Px 0Px 5Px;
height: 30Px;
position: relative;
top: -5Px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/update_verification_popup.vue